import React, { SVGProps } from 'react';

export function BankOutlineIcon({
  color = '#004232',
  width = 16,
  height = 16,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 16 16' fill='none' {...props}>
      <title>Bank Outline Icon</title>
      <path d='M2 13.5H15' stroke={color} />
      <path d='M4 7.5V13.5' stroke={color} />
      <path d='M10 7.5V13.5' stroke={color} />
      <path d='M7 7.5V13.5' stroke={color} />
      <path d='M13 7.5V13.5' stroke={color} />
      <path
        d='M14 6.24889V7.5H3V6.24889L8.10406 2.63828C8.22196 2.54802 8.35947 2.5 8.50005 2.5C8.64053 2.5 8.77813 2.54802 8.89603 2.63828L14 6.24889Z'
        stroke={color}
      />
    </svg>
  );
}
